export function isSafeRedirectPath(redirectPath: string | undefined, baseSiteUrl: string | undefined, environmentName: string): boolean {
    if (!redirectPath) {
        return false;
    }

    if (environmentName !== 'local' && baseSiteUrl) {
        return redirectPath.startsWith(baseSiteUrl);
    }

    try {
        const redirectUrl = new URL(redirectPath);
        return redirectUrl.hostname === 'localhost';
    } catch {
        return false;
    }
}
